module.exports = __webpack_public_path__ + "static/img/clothes-black.fc30f41a.png";